/**
 * The dashboard's theme toggle — requirement 6.5's second half.
 *
 * Lives in the app rather than in `packages/ui` because it is a piece of dashboard chrome, not a
 * primitive: the site has no toggle and never will. What it does live on is `useTheme`, which reads
 * the class on `<html>` rather than holding its own copy, so the button and the page cannot disagree
 * and persistence is `applyTheme`'s job rather than this component's.
 *
 * `aria-pressed` rather than a checkbox: this is a two-state button, and the accessible name says
 * which state it is in so a screen reader user hears the current theme rather than only the action.
 *
 * Task 14 took the styling out. This shipped at Task 13 with its own class list — a rounded border, a
 * resting shadow, a hover fill, and a focus ring — every line of which was a copy of what `Button` now
 * owns. It is `Button variant="outline"` and nothing else, which is why
 * `packages/config/src/primitives-policy.test.ts` can assert that no app source writes an elevation or a
 * focus-ring utility at all: with this file's copy gone, there are none left to allow for.
 */
import { Button, useTheme } from '@apuestapr/ui';
import type { ReactElement } from 'react';

export const ThemeToggle = (): ReactElement => {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === 'dark';

  return (
    <Button variant="outline" onClick={toggleTheme} aria-pressed={dark}>
      {dark ? 'Tema oscuro' : 'Tema claro'}
    </Button>
  );
};
